module.exports = __webpack_public_path__ + "static/media/wheel.b49de161.png";